<template>
	<v-card flat class="">
		<v-card-title primary-title>
			Master Kuesioner Link
			<v-spacer></v-spacer>
			<v-btn small color="primary" dark class="mb-2" @click="add()">
				Tambah Data
			</v-btn>
		</v-card-title>
		<v-dialog v-model="dialog" max-width="500px">
			<v-card>
				<v-card-title>
					<span class="text-h6">{{ formTitle }}</span>
				</v-card-title>
				<v-card-text>
					<v-text-field v-model="form.editedItem.nama" outlined dense hide-details="" label="Nama :"
						class="mb-2"></v-text-field>
					<v-text-field v-model="form.editedItem.link" outlined dense hide-details="" label="Link :"
						class="mb-2"></v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-btn color="primary" @click="save()">
						Simpan
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-data-table :headers="table.headers" :items="table.items" :options.sync="tableOptions"
			:server-items-length="table.totalItems" :loading="table.loading" dense class="elevation-1">
			<template v-slot:item.link="{ item }">
				<a :href="item.link" target="_blank">{{ item.link }}</a>
			</template>
			<template v-slot:item.actions="{ item }">
				<v-icon small class="mr-2" @click="editItem(item)">
					{{ icons.mdiPencil }}
				</v-icon>
			</template>
			<template v-slot:no-data>
				<v-btn color="primary" @click="getDataFromApi">
					Reload
				</v-btn>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiEye, mdiPencil } from '@mdi/js'

const apiRoot = process.env.VUE_APP_APIROOT
export default {
	components: {
	},
	data: () => ({
		icons: {
			mdiEye,
			mdiPencil,
		},
		tableOptions: {},
		table: {
			loading: true,
			headers: [
				{ text: 'No', align: 'start', sortable: false, value: 'no' },
				{ text: 'Nama', align: 'start', sortable: false, value: 'nama' },
				{ text: 'Link', align: 'start', sortable: false, value: 'link' },
				{ text: 'Aksi', align: 'start', sortable: false, value: 'actions' },
			],
			items: [],
			totalItems: 0,
		},
		dialog: false,
		form: {
			editedIndex: -1,
			editedItem: {
				id: '',
				nama: '',
				link: ''
			},
			defaultItem: {
				id: '',
				nama: '',
				link: '',
			},
		}
	}),
	watch: {
		tableOptions: {
			handler() {
				this.getDataFromApi()
			},
			deep: true,
		},
	},
	computed: {
		formTitle() {
			return this.form.editedIndex === -1 ? 'Tambah Data' : 'Edit Data'
		},
		// user() {
		// 	return this.$store.getters.user
		// },
	},
	created() {
	},
	methods: {
		save() {
			if (this.form.editedIndex > -1) {
				const fmData = new FormData()
				fmData.append('aksi', 'update')
				fmData.append('id', this.form.editedItem.id)
				fmData.append('nama', this.form.editedItem.nama)
				fmData.append('link', this.form.editedItem.link)
				axiosPostAuth('api/Master/addUpdateKuesionerLink', fmData)
					.then(response => {
						if (response.code === 200) {
							this.$notify({
								type: 'success',
								title: 'Berhasil',
								text: response.message,
							});
							this.dialog = false
							this.getDataFromApi()
						}
						else {
							alert(response.message)
						}
					})
					.catch(error => {
						alert(error)
					})
			} else {
				const fmData = new FormData()
				fmData.append('aksi', 'add')
				fmData.append('nama', this.form.editedItem.nama)
				fmData.append('link', this.form.editedItem.link)
				axiosPostAuth('api/Master/addUpdateKuesionerLink', fmData)
					.then(response => {
						if (response.code === 200) {
							this.$notify({
								type: 'success',
								title: 'Berhasil',
								text: response.message,
							});
							this.getDataFromApi()
						}
						else {
							alert(response.message)
						}
					})
					.catch(error => {
						alert(error)
					})
			}
		},
		getDataFromApi() {
			const { page, itemsPerPage } = this.tableOptions
			const fmData = new FormData()
			fmData.append('page', page)
			fmData.append('itemsPerPage', itemsPerPage)
			fmData.append('search', '')
			axiosPostAuth('api/Master/getKuesionerLink_datatable', fmData)
				.then(response => {
					this.table.items = response.data
					this.table.totalItems = response.total
					this.table.loading = false
				})
				.catch(error => {
					alert(error)
				})
		},
		add() {
			this.form.editedItem = Object.assign({}, this.form.defaultItem)
			this.form.editedIndex = -1
			this.dialog = true
		},
		editItem(item) {
			this.form.editedIndex = this.table.items.indexOf(item)
			this.form.editedItem = Object.assign({}, item)
			this.dialog = true
		}
	},
}
</script>